import React from 'react';
import { useModal } from '@europrocurement/flexy-components';
import { FormalisteAssignModal, User, useUsersCtx } from '@europrocurement/l2d-modules';
import { PrescripteurApi, useSociete, useTiersService } from '@europrocurement/l2d-domain';
import { enqueueSnackbar } from 'notistack';

const usePrescriberFormaliste = () => {
    const { modalActions } = useModal();
    const { getUserById } = useUsersCtx();
    const { prescribersApi } = useTiersService();
    const xIdSociete = useSociete();

    const updateFormaliste = async (
        prescriber: PrescripteurApi,
        newFormaliste: User,
        onSubmit?: () => void,
    ) => {
        try {
            await prescribersApi.updateFormalistePrescripteurTiersItem({
                id: prescriber.id as unknown as string,
                tiersPrescripteurJsonldPrescripteurWriteFormaliste: {
                    formaliste: { id: newFormaliste.id },
                },
                xIdSociete,
            });

            enqueueSnackbar('Le formaliste assigné a bien été modifié');

            if (onSubmit) {
                onSubmit();
            }
        } catch (e) {
            console.error(e);
            enqueueSnackbar('Une erreur est survenue lors de la mise à jour du prescripteur', {
                variant: 'error',
            });
        }
    };

    const openFormalisteModal = (prescriber: PrescripteurApi, onSubmit?: () => void) => {
        const selectedFormalisteId = prescriber?.formaliste?.id
            ? (prescriber.formaliste?.id as number)
            : undefined;
        const formaliste = selectedFormalisteId ? getUserById(selectedFormalisteId) : undefined;

        modalActions.call(
            <FormalisteAssignModal
                selectedFormaliste={formaliste}
                onFormalisteAssign={(newFormaliste) =>
                    updateFormaliste(prescriber, newFormaliste, onSubmit)
                }
                title="Assigner un formaliste au prescripteur"
                submitButtonText="Assigner"
            />,
        );
    };

    return { openFormalisteModal };
};

export default usePrescriberFormaliste;
